import { Dialog, AppBar, Toolbar, Typography, Button, DialogContent, Grid, TextField, DialogActions, FormControlLabel, Switch } from "@mui/material"
import { useState, useRef, useEffect } from "react"
import { useLimitacaoConsumoService } from "../../../../../use-cases/limitacao-consumo"
import { useNavigationService } from "../../../../../use-cases/navigation"
import { useUIService } from "../../../../../use-cases/ui"
import { onlyNumbers } from "../../../../../utils"
import { useAppSelector } from "../../../../hooks/store-hooks"
import { ITipoUsuario } from "../../../../../application/models"
import CloseIcon from '@mui/icons-material/Close'

export const FormUpdateTravaConsumoUsuario = () => {
    // State
    const { updateLimitacaoConsumoUsuarioForm } = useAppSelector((state) => state.limitacaoConsumo)
    const { currentUser } = useAppSelector((state) => state.user)
    // Use State
    const [loading, setLoading] = useState<boolean>(true)
    // Use Ref
    const isFirstRender = useRef(false)
    // Useful variables
    const isDemais = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS
    const isTecnologiaDaInformacao = currentUser?.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO
    const isCliente = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE
    // Permissões de edição - Seguindo regra de Usuários: Apenas Demais e Cliente podem editar
    const canEdit = isDemais || isTecnologiaDaInformacao || isCliente
    // Service
    const {
        setUpdateLimitacaoConsumoUsuarioOpenForm,
        setUpdateLimitacaoConsumoUsuarioFormQuantidade,
        updateLimitacaoConsumoUsuario,
        setUpdateLimitacaoConsumoUsuarioFormAtivo
    } = useLimitacaoConsumoService()
    const { setAlert } = useUIService()
    const { navigateTo } = useNavigationService()
    // useEffect
    useEffect(() => {
        if (!isFirstRender.current) {
            setLoading(false)
            isFirstRender.current = true

            const { IdLimitacaoConsumoUsuario, IdGrupoTrava, IdUsuario } = updateLimitacaoConsumoUsuarioForm.fields
            const hasValidId = (IdLimitacaoConsumoUsuario && IdLimitacaoConsumoUsuario > 0) || (IdGrupoTrava && IdGrupoTrava > 0)
            if (!hasValidId || !IdUsuario || IdUsuario === 0) {
                navigateTo({
                    route: '/dashboard/trava/consumo'
                })
            }
        }
    }, [updateLimitacaoConsumoUsuarioForm.fields.IdLimitacaoConsumoUsuario, updateLimitacaoConsumoUsuarioForm.fields.IdGrupoTrava, updateLimitacaoConsumoUsuarioForm.fields.IdUsuario, navigateTo])
    // Function
    const handleClose = () => {
        setUpdateLimitacaoConsumoUsuarioOpenForm({
            open: false
        })
    }

    return (
        loading ? <></>
            : <>
                <Dialog
                    open={true}
                    fullScreen
                    disableEscapeKeyDown
                    onClose={handleClose}
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
                                {canEdit ? 'Atualizar trava de consumo' : 'Visualizar trava de consumo'}
                            </Typography>
                            <Button
                                color="inherit"
                                startIcon={<CloseIcon />}
                                onClick={handleClose}
                                aria-label="close"
                            >
                                Fechar
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <DialogContent dividers={true}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={8}>
                                <TextField
                                    value={
                                        updateLimitacaoConsumoUsuarioForm.fields.Quantidade === 0 ? ''
                                            : updateLimitacaoConsumoUsuarioForm.fields.Quantidade.toLocaleString('pt-BR')
                                    }
                                    onChange={(e) => {
                                        setUpdateLimitacaoConsumoUsuarioFormQuantidade({
                                            Quantidade: Number(onlyNumbers(e.target.value))
                                        })
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    error={Boolean(updateLimitacaoConsumoUsuarioForm.touched && updateLimitacaoConsumoUsuarioForm.errors.find(item => item.key === 'Quantidade'))}
                                    helperText={updateLimitacaoConsumoUsuarioForm.errors.find(item => item.key === 'Quantidade')?.message}
                                    name="quantidade"
                                    fullWidth
                                    id="quantidade"
                                    label="Quantidade"
                                    autoFocus
                                    disabled={!canEdit}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <FormControlLabel
                                    label={updateLimitacaoConsumoUsuarioForm.fields.Ativo === true ? 'Trava de consumo ativa' : 'Trava de consumo inativa'}
                                    control={
                                        <Switch
                                            checked={updateLimitacaoConsumoUsuarioForm.fields.Ativo}
                                            onChange={(e) => {
                                                setUpdateLimitacaoConsumoUsuarioFormAtivo({
                                                    Ativo: e.target.checked
                                                })
                                            }}
                                            name="Ativo"
                                            color="primary"
                                            disabled={!canEdit}
                                        />
                                    }
                                />
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Fechar</Button>
                        {canEdit && (
                            <Button onClick={updateLimitacaoConsumoUsuario} variant="contained">Atualizar trava de consumo</Button>
                        )}
                    </DialogActions>
                </Dialog>
            </>
    )
}